<template>
  <VBottomSheet v-model="isOpen">
    <div
      class="d-flex flex-column overflow-hidden bg-white rounded-t-xl"
      style="height: 90vh; max-height: 90vh"
    >
      <NotificationPanel
        :notifications="notifications"
        :loading="isFetching"
        closeIcon="chevronDown"
        @close="close"
        @delete-all="deleteAll"
        @mark-all-read="markAllRead"
        @delete="deleteOne"
        @open="openNotification"
      />
    </div>
  </VBottomSheet>
</template>

<script lang="ts" setup>
import { VBottomSheet } from 'vuetify/components'
import NotificationPanel from '@/modules/Notification/components/NotificationPanel/NotificationPanel.vue'
import { useNotificationPanel } from '@/modules/Notification/composables/useNotificationPanel'

defineOptions({
  name: 'NotificationSheet',
})

const {
  isOpen,
  notifications,
  isFetching,
  close,
  deleteAll,
  markAllRead,
  deleteOne,
  openNotification,
} = useNotificationPanel()
</script>
